import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import i18n from "./i18n";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import "vuetify/dist/vuetify.min.css";
import VueTelInput from "vue-tel-input";
import IdleVue from "idle-vue";
import "vue-tel-input/dist/vue-tel-input.css";
import "@fortawesome/fontawesome-free/js/all.js";
import ReadMore from "vue-read-more";

import VueSocialSharing from "vue-social-sharing";

Vue.use(VueSocialSharing);
Vue.use(ReadMore);

Vue.use(VueTelInput);
Vue.config.productionTip = false;
window.data_saveds = false;

import "./css/style.scss";
import "./css/bootstraplib.scss";

const eventsHub = new Vue();
const idleTime = 5400000; //  90 mins

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime,
  startAtIdle: false,
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
